module.exports = __webpack_public_path__ + "img/3-top.ed4a2378.png";